// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a8a589d4","453":"8528f3b4","455":"13159b24","977":"85ccb95e"}[chunkId] + ".chunk.js";
};